var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells",class:[_vm.prefixCls,!_vm.showBorderTop?'clear-top':'',!_vm.showBorderBottom?'clear-bottom':''],on:{"click":_vm.clickHandler}},[_c('div',{staticClass:"weui-cell"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54556ddc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title-cell/title-cell.vue
// module id = 274
// module chunks = 0